var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpCancel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.125,
    height: 29.002,
    viewBox: "0 0 32.125 29.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-cancel-6792459",
    d: "M94.65,145.034h2.43v2.418H94.65Zm5.8,2.418h2.43v-2.418h-2.43Zm8.243-2.418h-2.433v2.418h2.433Zm3.34,2.418h2.43v-2.418h-2.429ZM94.65,153.665h2.43v-2.417H94.65Zm5.8,0h2.43v-2.417h-2.43Zm-5.8,5.769h2.43v-2.406H94.65Zm5.8,0h2.43v-2.406h-2.43Zm20.187-17.348v18.508a4.306,4.306,0,0,1-4.317,4.3H92.827a4.306,4.306,0,0,1-4.317-4.3V142.085a4.307,4.307,0,0,1,4.317-4.3h2.92v-1.9h1.571v1.9h6.47v-1.9h1.571v1.9h6.449v-1.9h1.571v1.9h2.94a4.307,4.307,0,0,1,4.317,4.3Zm-1.571,0a2.727,2.727,0,0,0-.8-1.933,2.756,2.756,0,0,0-1.943-.8h-2.941v2h-1.571v-2h-6.45v2h-1.569v-2h-6.47v2H95.748v-2h-2.92a2.74,2.74,0,0,0-2.747,2.734v18.508a2.74,2.74,0,0,0,2.747,2.734h23.49a2.74,2.74,0,0,0,2.747-2.734Zm-5.931,9.263-2.779,2.765-2.779-2.765-1.111,1.106,2.779,2.765-2.779,2.765,1.111,1.106,2.779-2.765,2.779,2.765,1.111-1.106-2.779-2.765,2.779-2.765Z",
    transform: "translate(-88.51 -135.887)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCancel);
export default __webpack_public_path__ + "static/media/helpCancel.027e37a90eda25423f46a5460cce836f.svg";
export { ForwardRef as ReactComponent };